import { render } from "./AttendeePrivacyPolicy.vue?vue&type=template&id=4a724dbc"
import script from "./AttendeePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./AttendeePrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__